module.exports = __webpack_public_path__ + "static/media/pg20.4221944c.jpg";